import axios from 'axios';
import normalizeOpenWeather from './normalizeOpenWeather';
import normalizeWeatherApi from './normalizeWeatherApi';
import normalizeVisualCrossing from './normalizeVisualCrossing';

const { REACT_APP_VISUALCROSSING_KEY, REACT_APP_OPENWEATHER_KEY, REACT_APP_WEATHERAPI_KEY } = process.env;

const getDataFromOrigin = async (originName, currentCity, setOriginData, setLoading) => {
	let originUrl;
	let normalizeData;

	// Openweathermap permite 1 millón de llamadas al mes, 60 máx. por minuto.
	if (originName === 'openweather'){
		originUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${currentCity.lat}&lon=${currentCity.long}&appid=${REACT_APP_OPENWEATHER_KEY}&lang=es&units=metric`;
		normalizeData = normalizeOpenWeather;

	// Weather API permite 1 millón de llamadas al mes, 30.000 al día.
	} else if (originName === 'weatherapi'){
		originUrl = `https://api.weatherapi.com/v1/forecast.json?key=${REACT_APP_WEATHERAPI_KEY}&q=${currentCity.lat},${currentCity.long}&days=10&aqi=no&alerts=no`;
		normalizeData = normalizeWeatherApi;

	// Visualcrossing permite 1000 llamadas al día.
	} else {
		originUrl = `https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/${currentCity.lat},${currentCity.long}?unitGroup=metric&include=fcst,hours,current&key=${REACT_APP_VISUALCROSSING_KEY}`;
		normalizeData = normalizeVisualCrossing;
	}

	const response = await axios.get(originUrl)
		.then(function (response) {
			return normalizeData(response.data);
		})
		.catch(function (error) {
			return error.message;
		});

	setOriginData(response);
	setLoading(false);
}

export default getDataFromOrigin;
